export class Permissoes {
  constructor({
    id,
    nome,
  }) {
    this.id = id;
    this.nome = nome;
  }
}
